module.exports = __webpack_public_path__ + "img/block-375.cc99ca62.jpg";